<template>
  <section class="content" :style="{ padding: '0 .99rem !important' }">
    <div class="card">
      <div class="card-body d-flex align-items-center flex-wrap">
        <div style="width: 100%">
          <h3 style="text-align: left">Datos Generales</h3>
          <hr />
        </div>
      </div>
      <div class="accordion" id="accordionExample" style="padding: 0 1rem">
        <div class="container mt-4">
          <form @submit.prevent="submitForm">
            <!-- Sección: Información General -->
            <h5 class="encabezado-form">Información General</h5>
            <div class="row">
              <div class="col-md-9 form-group">
                <label>Nombre de la empresa</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="199"
                  v-model="formData.nombre"
                  required
                />
              </div>
              <div class="col-md-3 form-group">
                <label>RFC</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="19"
                  v-model="formData.rfc"
                  required
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label
                  >Departamento que propone la elaboración del presente
                  estudio:</label
                >
                <input
                  type="text"
                  class="form-control"
                  maxlength="199"
                  v-model="formData.departamento"
                  required
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Domicilio</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="199"
                  v-model="formData.domicilio"
                  required
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 form-group">
                <label>Actividad desarrollada:</label>
                <textarea
                  type="text"
                  class="form-control"
                  maxlength="499"
                  v-model="formData.actividad"
                  required
                ></textarea>
              </div>
            </div>

            <!-- Sección: Contacto y Autorizaciones -->
            <hr />
            <h5 class="encabezado-form">Contacto y Autorizaciones</h5>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Correo electrónico</label>
                <input
                  type="email"
                  class="form-control"
                  maxlength="300"
                  v-model="formData.email"
                  required
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Teléfono(s)</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="39"
                  v-model="formData.telefono"
                  required
                  placeholder="6671956789, 6672123342"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Persona Autorizada (Nombre)</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="199"
                  v-model="formData.persona_autorizada_nombre"
                  required
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Persona Autorizada (Puesto)</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="99"
                  v-model="formData.persona_autorizada_puesto"
                  required
                />
              </div>
            </div>

            <!-- Sección: Características del Inmueble -->
            <hr />
            <h5 class="encabezado-form">Características del Inmueble</h5>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Superficie Total (M2)</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="19"
                  v-model="formData.superficie_total"
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Superficie Construida (M2)</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="19"
                  v-model="formData.superficie_construida"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Niveles de Construcción</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="19"
                  v-model="formData.niveles_construccion"
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Inventario de Gas LP</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="49"
                  v-model="formData.inventario_gas"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Horario de Operación</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="49"
                  v-model="formData.horario_operacion"
                  required
                  placeholder="06:00 AM A 18:30 AM"
                />
              </div>
            </div>

            <!-- Sección: Recursos y Seguridad -->
            <hr />
            <h5 class="encabezado-form">Recursos y Seguridad</h5>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Total de Empleados</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="formData.total_empleados"
                  required
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Logo</label>

                <!-- Si hay un logo guardado, mostrar mensaje y botón de modificar -->
                <div
                  class="d-flex justify-content-center align-items-center"
                  style="gap: 10px"
                  v-if="formData.logo && !modificarLogo"
                >
                  <p style="color: green; margin: 0">
                    Ya hay un logo guardado <i class="fa fa-check"></i>
                  </p>
                  <button
                    type="button"
                    class="btn btn-warning btn-sm"
                    @click="modificarLogo = true"
                  >
                    Modificar Logo
                  </button>
                </div>
                <input
                  v-if="modificarLogo || !formData.logo"
                  type="file"
                  id="fileInput"
                  class="form-control mt-2"
                />
              </div>
            </div>

            <div class="row" v-if="Number(giro) != 16 || giro != 'Guarderia'">
              <div class="col-md-6 form-group">
                <label>Maquinaria y equipamiento utilizado</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="200"
                  v-model="formData.equipamiento"
                  required
                />
              </div>
              <div class="col-md-6 form-group">
                <label
                  >Uso de materiales tóxicos, flamables y recipientes sujetos a
                  presión</label
                >
                <input
                  type="text"
                  class="form-control"
                  maxlength="200"
                  v-model="formData.materiales"
                  required
                />
              </div>
            </div>
            <hr />
            <div v-if="Number(giro) === 16 || giro === 'Guarderia' || Number(giro) === 11 || giro === 'Educativa'">
              <h5 class="encabezado-form" style="text-align: start">
                Guarderia / Preescolar <small>(En caso de aplicar)</small>
              </h5>
              <div class="row">
                <div class="col-md-3 form-group">
                  <label>No. de niños inscritos</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.no_niños"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>No. maximo de niños inscritos</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.no_niños_max"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>Superficie total de aulas</label>
                  <input
                    type="text"
                    maxlength="20"
                    class="form-control"
                    v-model="formData.sup_total_aulas"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>No. de docentes</label>
                  <input
                    type="text"
                    maxlength="20"
                    class="form-control"
                    v-model="formData.g_docentes"
                  />
                </div>
              </div>
              <h5 class="encabezado-form" style="text-align: start">
                Primaria <small>(En caso de aplicar)</small>
              </h5>
              <div class="row">
                <div class="col-md-3 form-group">
                  <label>No. de niños inscritos</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.p_no_ninos"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>No. de docentes</label>
                  <input
                    type="text"
                    maxlength="20"
                    class="form-control"
                    v-model="formData.p_no_docentes"
                  />
                </div>
              </div>
              <h5 class="encabezado-form" style="text-align: start">
                Secundaria <small>(En caso de aplicar)</small>
              </h5>
              <div class="row">
                <div class="col-md-3 form-group">
                  <label>No. de niños inscritos</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.s_no_ninos"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>No. de docentes</label>
                  <input
                    type="text"
                    maxlength="20"
                    class="form-control"
                    v-model="formData.s_no_docentes"
                  />
                </div>
              </div>
              <h5 class="encabezado-form" style="text-align: start">
                Preparatoria <small>(En caso de aplicar)</small>
              </h5>
              <div class="row">
                <div class="col-md-3 form-group">
                  <label>No. de niños inscritos</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.prepa_no_ninos"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>No. de docentes</label>
                  <input
                    type="text"
                    maxlength="20"
                    class="form-control"
                    v-model="formData.prepa_no_docentes"
                  />
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary m-3">
              Actualizar
            </button>
          </form>
        </div>
      </div>
    </div>
    <FlashMessage
      :style="{ position: 'fixed', zIndex: 9999, fontSize: '18px' }"
    ></FlashMessage>
    <div v-if="loading" class="spinner-overlay">
      <div
        class="spinner-border text-primary"
        style="width: 3rem; height: 3rem"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </section>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";

export default {
  name: "CentroAyuda",
  data() {
    return {
      modificarLogo: false,
      loading: false,
      formData: {
        rfc: "",
        nombre: "",
        departamento: "",
        domicilio: "",
        email: "",
        telefono: "",
        actividad: "",
        persona_autorizada_nombre: "",
        persona_autorizada_puesto: "",
        superficie_total: "",
        superficie_construida: "",
        niveles_construccion: "",
        inventario_gas: "",
        horario_operacion: "",
        total_empleados: "",
        materiales: null,
        equipamiento: null,
        no_niños: null,
        no_niños_max: null,
        sup_total_aulas: null,
        g_docentes: null,
        p_no_ninos: null,
        p_no_docentes: null,
        s_no_ninos: null,
        s_no_docentes: null,
        prepa_no_ninos: null,
        prepa_no_docentes: null,
        antiguedad_inmueble: "",
        logo: "",
      },
      giro: null,
      ser_doc_id: null,
    };
  },
  methods: {
    async submitForm() {
      const formData = new FormData(); // Crear un nuevo objeto FormData
      const fileInput = document.getElementById("fileInput");

      if (fileInput && fileInput.files.length > 0) {
        const file = fileInput.files[0];

        const maxSizeMB = 50;
        const maxSizeBytes = maxSizeMB * 1024 * 1024;

        const allowedExtensions = [
          "jpg",
          "jpeg",
          "png",
          "gif",
          "webp",
          "tiff",
          "svg",
          "eps",
          "pdf",
          "ai",
          "psd",
          "doc",
          "docx",
        ];
        const allowedMimeTypes = [
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/webp",
          "image/tiff",
          "image/svg+xml",
          "application/postscript",
          "application/pdf",
          "application/vnd.adobe.illustrator",
          "image/vnd.adobe.photoshop",
          "application/msword", // Para archivos .doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Para archivos .docx
        ];

        if (file) {
          const fileExtension = file.name.split(".").pop().toLowerCase();

          if (!allowedExtensions.includes(fileExtension)) {
            this.flashMessage.error({
              message: "[ERROR]: Tipo de archivo no permitido",
            });
            fileInput.value = ""; // Resetear input
            return;
          }

          if (!allowedMimeTypes.includes(file.type)) {
            this.flashMessage.error({
              message: "[ERROR]: Tipo MIME no permitido",
            });
            fileInput.value = ""; // Resetear input
            return;
          }

          if (file.size > maxSizeBytes) {
            this.flashMessage.error({
              message: `[ERROR]: El archivo es demasiado grande. Máximo permitido: ${maxSizeMB} MB`,
            });
            fileInput.value = ""; // Resetear input
            return;
          }

          formData.append("file", file);
        }
      }

      formData.append("formData", JSON.stringify(this.formData));
      formData.append("id", this.$route.params.id);
      formData.append("ser_doc_id", this.ser_doc_id);
      this.loading = true;
      try {
        await axiosInstance.post("/users/updateDatosGenerales", formData, {
          headers: {
            "Content-Type": "multipart/form-data", //Enviar archivos
          },
        });
        this.flashMessage.success({
          message: "[ÉXITO]: Datos generales actualizados con éxito",
          time: 2000,
        });
        this.$router.go(-1);
      } catch (error) {
        this.flashMessage.error({
          message: "[ERROR]: Hubo un problema al actualizar",
        });
      } finally {
        this.loading = false;
      }
    },
    async index(id) {
      this.loading = true;
      try {
        const response = await axiosInstance.get("/users/DatosGenerales", {
          params: {
            id: id,
          },
        });
        if (response.data) {
          this.formData = response.data;
        }
        if (response.data.message === "err") {
          this.$router.push("/home");
        }
        this.loading = false;
      } catch (error) {
        this.flashMessage.error({
          message: "[ERROR]: Ocurrio un error inesperado",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.index(this.$route.params.id);
  },
  created() {
    this.giro = this.$route.query.giro;
    this.ser_doc_id = this.$route.query.ser_doc_id;
  },
};
</script>

<style>
hr {
  margin: 20px 0;
}
.form-group label {
  font-weight: 400 !important;
}

.encabezado-form {
  margin-bottom: 2rem !important;
}
</style>
